/* eslint-disable  */
import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Loader from "../../Components/Loader";
import RenderLoanPage from "../RenderLoanPage";
import * as moment from "moment";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { notificationsActionCreators } from "../../services/Actions";

// Deterministic avatar gradient based on the notification title
const AVATAR_GRADIENTS = [
  "from-green-500 to-emerald-600",
  "from-blue-500 to-indigo-600",
  "from-purple-500 to-fuchsia-600",
  "from-amber-500 to-orange-600",
  "from-rose-500 to-pink-600",
  "from-cyan-500 to-sky-600",
];

function gradientFor(text = "") {
  let sum = 0;
  for (let i = 0; i < text.length; i++) sum += text.charCodeAt(i);
  return AVATAR_GRADIENTS[sum % AVATAR_GRADIENTS.length];
}

function LoansNotifications() {
  const dispatch = useDispatch();
  const { GetNotificationsByLoanOfficers, ResetResponse, DeleteNotification } =
    bindActionCreators(notificationsActionCreators, dispatch);

  const notificationsObj = useSelector((state) => state?.notification);
  const { isLoading, notifications } = notificationsObj;

  useEffect(() => {
    GetNotificationsByLoanOfficers();
  }, []);

  return (
    <RenderLoanPage title={""}>
      {isLoading && <Loader />}
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 p-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="mb-8 flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                Notifications
              </h1>
              <p className="text-gray-600 dark:text-gray-400">
                Stay up to date with loan department activity
              </p>
            </div>
            {notifications?.length > 0 && (
              <span className="inline-flex items-center justify-center px-3 py-1 text-sm font-semibold rounded-full bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300">
                {notifications.length}
              </span>
            )}
          </div>

          {/* Notifications Card */}
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700">
            {notifications?.length > 0 ? (
              <div className="divide-y divide-gray-100 dark:divide-gray-700">
                {notifications?.map((notification) => {
                  const initial = (notification?.title || "?")
                    .trim()
                    .charAt(0)
                    .toUpperCase();
                  return (
                    <div
                      key={notification?._id}
                      className="group flex items-start gap-4 px-5 py-4 transition-colors hover:bg-gray-50 dark:hover:bg-gray-700/50"
                    >
                      {/* Avatar */}
                      <div
                        className={`flex-shrink-0 w-11 h-11 rounded-full bg-gradient-to-br ${gradientFor(
                          notification?.title
                        )} flex items-center justify-center text-white font-semibold shadow-sm`}
                      >
                        {initial}
                      </div>

                      {/* Content */}
                      <div className="min-w-0 flex-1">
                        <h5 className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                          {notification?.title}
                        </h5>
                        <p className="text-sm text-gray-600 dark:text-gray-300 mt-0.5 line-clamp-2">
                          {notification?.message}
                        </p>
                        <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                          {moment(notification?.created_at).calendar()}
                        </p>
                      </div>

                      {/* Delete */}
                      <button
                        type="button"
                        title="Delete notification"
                        onClick={() => DeleteNotification(notification?._id)}
                        className="flex-shrink-0 p-2 rounded-full text-gray-400 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 transition-colors opacity-0 group-hover:opacity-100 focus:opacity-100"
                      >
                        <svg
                          className="w-5 h-5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                      </button>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="px-6 py-16 text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center">
                  <svg
                    className="w-8 h-8 text-gray-400 dark:text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-1">
                  No Notifications Yet
                </h3>
                <p className="text-gray-500 dark:text-gray-400">
                  New notifications will appear here as they arrive.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <ToastContainer autoClose={3000} />
    </RenderLoanPage>
  );
}

export default LoansNotifications;
